export default "__VITE_ASSET__CZm2_C2P__"